module.exports = __webpack_public_path__ + "static/media/today-bookings.style.838d7c2d.less";